import { render, staticRenderFns } from "./OfferNotesCreate.vue?vue&type=template&id=fffc791e&scoped=true&"
import script from "./OfferNotesCreate.vue?vue&type=script&lang=js&"
export * from "./OfferNotesCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fffc791e",
  null
  
)

export default component.exports